export const generalRequirementHeaderForm = (
  <span>
    Llena el siguiente formulario con los datos del{" "}
    <span className="font-semibold text-gray-900">solicitante</span>.
  </span>
);

export const generalRequirementHeaderDocument = (
  <span>
    Adjunta la documentación solicitada. Los documentos deben ser{" "}
    <span className="font-semibold text-gray-900">legibles y completos</span>.
  </span>
);
